// Get elements by class name
const productsOnPage = document.querySelector(".products-onpage")
const loadMoreBtn = document.querySelector(".load-more-btn")
const loadMoreSpinner = document.querySelector(".load-more-spinner")
const productGrid = document.getElementById("product-grid")
const customShowProduct = document.querySelector(".custom-show-product")
const customTotalProduct = document.querySelector(".custom-total-product")
const loadMoreProgressBar = document.querySelector(".load-more-progress-bar")
const swatchesImageChange = document.querySelectorAll(
  ".custom-product-swatches input",
)

const isYotpoRatingMinActive = () => {
  try {
    return !!(
      new URLSearchParams(window.location.search).get("yotpo_rating_min") || ""
    ).trim()
  } catch (_) {
    return false
  }
}

const parseLastPositiveInt = (text) => {
  const matches = String(text || "").match(/\d[\d,]*/g) || []
  const last = matches.length ? matches[matches.length - 1] : ""
  const n = parseInt(String(last).replace(/,/g, ""), 10)
  return Number.isFinite(n) && n > 0 ? n : 0
}

const getProductGridRoot = () =>
  document.querySelector("[data-search-show-more-grid]") ||
  document.getElementById("product-grid")

const getLoadedProductItems = () => {
  try {
    const grid = getProductGridRoot()
    if (!grid) return []
    return Array.from(
      grid.querySelectorAll(
        "li.grid__item:not(.daily-deals-injected):not(.yotpo-rating-filter-hidden):not([hidden]):not(.hidden)",
      ),
    )
  } catch (_) {
    return []
  }
}

// Gated products are removed server side, so the grid renders a wide window and
// reveals a page at a time. That keeps each view full instead of leaving the
// gaps the removed products would otherwise leave in the last row.
const getHiddenProductItems = () => {
  try {
    const grid = getProductGridRoot()
    if (!grid) return []
    return Array.from(
      grid.querySelectorAll(
        "li.grid__item[hidden]:not(.daily-deals-injected), li.grid__item.hidden:not(.daily-deals-injected)",
      ),
    ).filter((el, index, list) => list.indexOf(el) === index)
  } catch (_) {
    return []
  }
}

const revealHiddenProducts = () => {
  const hiddenItems = getHiddenProductItems()
  if (!hiddenItems.length) return 0

  const perPage =
    parseInt(
      document.querySelector(".custom-show-product")?.dataset?.perPage || "36",
      10,
    ) || 36
  hiddenItems.slice(0, perPage).forEach((el) => {
    el.removeAttribute("hidden")
    el.classList.remove("hidden")
  })
  return Math.min(perPage, hiddenItems.length)
}

// Initialize variables

let nextUrl = productsOnPage ? productsOnPage.dataset.nextUrl : null

// Function to load more products
const loadMoreProducts = () => {
  if (document.querySelector("[data-search-show-more-grid]")) return

  // Reveal what is already rendered before fetching the next window.
  if (revealHiddenProducts()) {
    countTotalProduct()
    if (typeof initBadges === "function") initBadges()
    if (typeof checkProductCardsPromoTextHeight === "function") {
      checkProductCardsPromoTextHeight()
    }
    syncLoadMoreVisibility()
    document.dispatchEvent(
      new Event("more:products:loaded", { bubbles: true, composed: true }),
    )
    return
  }

  if (!nextUrl) {
    loadMoreBtn.style.display = "none"
    return
  }

  // Show spinner, hide load more button
  loadMoreBtn.style.display = "none"
  loadMoreSpinner.classList.remove("hidden")

  // Make AJAX request
  fetch(nextUrl)
    .then((response) => response.text())
    .then((data) => {
      // Hide spinner
      loadMoreSpinner.classList.add("hidden")

      // Create a temporary div to parse the HTML string
      const tempDiv = document.createElement("div")
      tempDiv.innerHTML = data

      // Find new products
      const newProducts = tempDiv.querySelector(".products-onpage")
      if (!newProducts) return

      nextUrl = newProducts.dataset.nextUrl

      // Show load more button if there's more to load
      if (nextUrl) {
        loadMoreBtn.style.display = "inline-flex"
      }

      // Append new products to the existing ones
      productsOnPage.innerHTML += newProducts.innerHTML

      // hide solo swatches
      getLoadedProductItems().forEach((el) => {
        const swatches = el.querySelectorAll(".custom-product-swatches")
        if (swatches.length === 1) swatches[0].style.display = "none"
      })

      // Recount total products
      countTotalProduct()
      initBadges()
      checkProductCardsPromoTextHeight()
    })
    .catch((error) => {
      console.error("Error:", error)
      // Hide spinner and show load more button in case of error
      loadMoreSpinner.style.display = "none"
      loadMoreBtn.style.display = "inline-flex"
    })
    .finally(() => {
      document.dispatchEvent(
        new Event("more:products:loaded", { bubbles: true, composed: true }),
      )
    })
}

const getCollectionTotal = () => {
  const gatedTotal = Number(window.__gatedCollectionTotal)
  if (Number.isFinite(gatedTotal) && gatedTotal > 0) return gatedTotal
  const searchCount = Number(window.Shopify?.searchResults?.count)
  if (Number.isFinite(searchCount) && searchCount > 0) return searchCount
  return (
    parseInt(
      document.querySelector(".custom-total-product")?.textContent || "0",
      10,
    ) || 0
  )
}

// Function to count total products
const countTotalProduct = () => {
  // Rating filter is handled by `custom-filter-facets.js` and can load/append pages.
  // Avoid clobbering the “visible out of total” UI while it is active.
  if (isYotpoRatingMinActive()) return

  const resultCount = getLoadedProductItems().length
  if (customShowProduct) {
    const countContainer =
      document.getElementById("ProductCount") ||
      document.getElementById("ProductCountDesktop")
    customShowProduct.textContent = resultCount
    if (
      getHiddenProductItems().length === 0 &&
      !nextUrl &&
      getLoadedProductItems().length >= getCollectionTotal()
    ) {
      if (countContainer) {
        countContainer.textContent = countContainer.textContent.replace(
          /[\d]+/,
          resultCount,
        )
      }
      customTotalProduct.textContent = resultCount
    } else {
      const totalFromTemplates = parseInt(
        document
          .getElementById("CollectionTrueTotal")
          ?.getAttribute("data-collection-total") || "0",
        10,
      )
      const totalFromCount = parseLastPositiveInt(
        countContainer?.textContent || "",
      )
      const gatedAdjustedTotal = Number(window.Shopify?.searchResults?.count)
      const total =
        (Number.isFinite(gatedAdjustedTotal) && gatedAdjustedTotal > 0
          ? gatedAdjustedTotal
          : 0) ||
        totalFromTemplates ||
        totalFromCount ||
        resultCount
      customTotalProduct.textContent = String(total)
    }
  }
  const totalResultsElem = customTotalProduct
  const totalResults = totalResultsElem
    ? parseInt(totalResultsElem.textContent, 10)
    : 0
  const finalWidth = totalResults ? (resultCount * 100) / totalResults : 0

  // Ensure finalWidth doesn't exceed 100%
  const progressBar = loadMoreProgressBar
  if (progressBar) {
    progressBar.style.width = `${Math.min(finalWidth, 100)}%`
  }
}

const syncLoadMoreVisibility = () => {
  const btn = document.querySelector(".load-more-btn")
  const wrap = document.querySelector(".load-more")
  if (!btn) return

  const visible = getLoadedProductItems().length
  const hiddenCount = getHiddenProductItems().length
  const total = getCollectionTotal()
  const hasMore = hiddenCount > 0 || !!nextUrl || (total > 0 && visible < total)

  btn.style.display = hasMore ? "inline-flex" : "none"
  btn.classList.toggle("hidden", !hasMore)
  if (wrap) wrap.style.display = hasMore ? "" : "none"
}

// Initial count. Re-run after DOMContentLoaded (and once more on the
// next tick) so later scripts that recount every in-DOM card cannot
// hide Show more on first paint.
countTotalProduct()
syncLoadMoreVisibility()
document.addEventListener("DOMContentLoaded", () => {
  countTotalProduct()
  syncLoadMoreVisibility()
  setTimeout(() => {
    countTotalProduct()
    syncLoadMoreVisibility()
  }, 0)
})

// Search results have their own 36-at-a-time reveal. Do not also bind
// this collection handler or one click unhides the whole aggregated grid.
if (loadMoreBtn && !loadMoreBtn.matches("[data-search-show-more-button]")) {
  loadMoreBtn.addEventListener("click", loadMoreProducts)
}

document.addEventListener("DOMContentLoaded", function () {
  const sortSelect = document.querySelector("#SortBy")
  if (sortSelect) {
    sortSelect.addEventListener("click", function () {
      console.log("Sort changed")
    })
  }
})
